import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import projectStatus from "@/helpers/projectStatus";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        configurator: {
            id: null,
            surfaces: [],
            customer: {
                isCompany: false
            },
            partner: null,
            offer: {
                currency: {},
                items: []
            },
            projects: {
                status: projectStatus.unavailable,
                items: []
            },
            currency: {
                rate: 1,
                code: "PLN",
                language: "pl",
                symbol: "zł"
            },
            defaultCurrency: {},
            rate: 1
        },
        materials: {
            loaded: false,
            planks: [],
            surfaces: [],
            joists: [],
            slats: [],
            additionals: [],
            stair: [],
            elevation: [],
            allslats: [],
            corner: [],
            systems: []

        },
        manualMaterials: {
            loaded: false,
            planks: [],
            surfaces: [],
            joists: [],
            slats: [],
            additionals: [],
            stair: [],
            elevation: [],
            allslats: [],
            corner: []

        },
        items: [],
        users: [],
        company: {},
        currentStep: null,
        currencies: [],
        locale: 'pl',
        system: 'terrace'
    },
    getters,
    mutations,
    actions
})
